import React from "react";
import { Text } from "react-native-paper";
import { View } from "react-native";
import AccordionItem from "../AccordionItem";

const AccordionItemText = ({ styles, j, subSection }) => {
  const txt = (
    <View style={styles.textdescriptionDesign}>
      <AccordionItem subSection={subSection} />
    </View>
  );
  const tit = <Text style={styles.textSubtitle}>{subSection.title}</Text>;
  return (
    <View style={{ paddingBottom: 10, paddingTop: 10 }}>
      <View style={styles.subSection} key={j}>
        {subSection.positionText === "right" ? (
          <>
            {tit}
            {txt}
          </>
        ) : (
          <>
            {txt}
            {tit}
          </>
        )}
      </View>
    </View>
  );
};

export default AccordionItemText;
